import React, {useEffect, useState} from "react";
import {Button, DatePicker, Input, Modal} from "antd";
import dayjs from "dayjs";
import moment from "moment";

const dateFormat = "DD/MM/YYYY";

const Label = ({children}) => (
    <div className="text-[12px] font-semibold text-[#7A849A] uppercase tracking-wide mb-1.5">
        {children}
    </div>
);

const EmailQueueSearchPopup = ({
                                   visible,
                                   onClose,
                                   setFormData,
                                   fetchQueueEmailData,
                                   listPagination,
                                   formData,
                               }) => {
    const [dateRange, setDateRange] = useState([]);

    useEffect(() => {
        if (formData && formData.fromDate && formData.toDate) {
            setDateRange([
                dayjs(formData.fromDate, dateFormat),
                dayjs(formData.toDate, dateFormat),
            ]);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleInputChange = (field, value) => {
        setFormData((prev) => {
            if (field === "fromDate" || field === "toDate") {
                const dateValue = moment(value).utc();
                return {...prev, [field]: dateValue.isValid() ? dateValue : null};
            }
            return {...prev, [field]: value};
        });
    };

    const handleDateChange = (dates, dateStrings) => {
        setDateRange(dates);
        setFormData((prev) => ({
            ...prev,
            fromDate: dateStrings[0],
            toDate: dateStrings[1],
        }));
    };

    const handleSearch = () => {
        listPagination.pageNumber = 1;

        const selectedValues = Object.entries(formData).reduce((acc, [key, value]) => {
            if (key !== "selectedItems" && value !== "" && value !== null) {
                acc[key] = value;
            }
            return acc;
        }, {});

        const [startDate, endDate] = dateRange || [];

        setFormData((prev) => ({...prev, selectedItems: [selectedValues]}));

        if (startDate && endDate) {
            fetchQueueEmailData({
                ...selectedValues,
                fromDate: startDate ? startDate.format(dateFormat) : null,
                toDate: endDate ? endDate.format(dateFormat) : null,
            });
        } else {
            fetchQueueEmailData(selectedValues);
        }

        onClose?.();
    };

    return (
        <Modal
            title="Advanced Search"
            open={visible}
            onCancel={onClose}
            width={560}
            closable={true}
            footer={[
                <Button key="cancel" onClick={onClose}>Cancel</Button>,
                <Button key="search" type="primary" onClick={handleSearch}>Search</Button>,
            ]}
        >
            <div className="flex flex-col gap-4">
                <div>
                    <Label>Subject</Label>
                    <Input
                        placeholder="Search by subject keywords"
                        value={formData.subject}
                        onChange={(e) => handleInputChange("subject", e.target.value)}
                        allowClear
                        onPressEnter={handleSearch}
                    />
                </div>

                <div>
                    <Label>Sender Email</Label>
                    <Input
                        placeholder="sender@example.com"
                        value={formData.senderEmail}
                        onChange={(e) => handleInputChange("senderEmail", e.target.value)}
                        allowClear
                        onPressEnter={handleSearch}
                    />
                </div>

                <div>
                    <Label>Queue Email</Label>
                    <Input
                        placeholder="queue@example.com"
                        value={formData.queueEmail}
                        onChange={(e) => handleInputChange("queueEmail", e.target.value)}
                        allowClear
                        onPressEnter={handleSearch}
                    />
                </div>

                <div>
                    <Label>Date Range</Label>
                    <DatePicker.RangePicker
                        format={dateFormat}
                        placeholder={["Start date", "End date"]}
                        value={
                            dateRange && dateRange.length > 0
                                ? [dayjs(dateRange[0]), dayjs(dateRange[1])]
                                : undefined
                        }
                        onChange={handleDateChange}
                        className="w-full"
                    />
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    <div>
                        <Label>Days</Label>
                        <Input
                            type="number"
                            placeholder="0"
                            value={formData.days}
                            onChange={(e) =>
                                handleInputChange("days", parseInt(e.target.value, 10) || "")
                            }
                            onPressEnter={handleSearch}
                        />
                    </div>
                    <div>
                        <Label>Reference Id</Label>
                        <Input
                            type="number"
                            value={formData.referenceId}
                            onChange={(e) =>
                                handleInputChange("referenceId", parseInt(e.target.value, 10) || "")
                            }
                            onPressEnter={handleSearch}
                        />
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default EmailQueueSearchPopup;
